var render = function (_h,_vm) {var _c=_vm._c;return _c('EbxEventButton',{staticClass:"ebx-dropdown__button",attrs:{"event":"sort-toggle-clicked"}},[_c('TuandcoCloseIcon',{attrs:{"slot":"icon"},slot:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }